import { render, staticRenderFns } from "./speech-component-vue.vue?vue&type=template&id=3f4a583f&shadow"
import script from "./speech-component-vue.vue?vue&type=script&lang=js&shadow"
export * from "./speech-component-vue.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports